import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import ContributionProductFields from './ContributionProductFields'

export const ContributionProductCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <ContributionProductFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default ContributionProductCreate
